import { useState } from 'react';
import ListView from '../../components/views/listView';
import SendIcon from '@mui/icons-material/Send';
import { Grid } from '@mui/material';
import FieldText from '../../components/general/fields/fieldText';
import { asyncPostCreateCaseOTRSPQROnTime } from '../../../services/caseOTRS.service';

export const CaseOTRS = () => {
    const [caseId, setCaseId] = useState('');
    const [res, setRes] = useState<{
        caseCreated: boolean;
        caseUpdated: boolean;
    }>();
    const [loading, setLoading] = useState(false);

    const onSend = async () => {
        setLoading(true);
        setRes(undefined);
        try {
            const res = await asyncPostCreateCaseOTRSPQROnTime(caseId);
            setRes(res as any);
            setCaseId('');
        } catch (error) {}
        setLoading(false);
    };

    return (
        <>
            <ListView
                title="Sincronización casos OTRS"
                startIconButtonAdd={<SendIcon color="secondary" />}
                titleButtonAdd="Radicar"
                disabledAdd={loading}
                onClickAdd={onSend}
                columns={[]}
                rows={[]}
                rowCount={0}
                disableBack
                enabledSearch={true}
                showList={false}
                searchField={
                    <Grid
                        container
                        spacing={{ xs: 1.5, md: 1.5 }}
                        columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
                    >
                        <Grid item xs={12}>
                            <FieldText
                                label="Caso"
                                name="caseId"
                                size="small"
                                value={caseId}
                                onChange={(value: any) =>
                                    setCaseId(value.target.value)
                                }
                            />
                        </Grid>
                    </Grid>
                }
            />
            <Grid textAlign="center" mt={5} fontSize={20}>
                {res &&
                    'Se gestiono el caso correctamente, por favor valide en OTRS, si tiene alguna dificultad intente nuevamente.'}
            </Grid>
        </>
    );
};
